import { render, staticRenderFns } from "./merge_checks.vue?vue&type=template&id=518bf6f1"
import script from "./merge_checks.vue?vue&type=script&lang=js"
export * from "./merge_checks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports